import Swiper, { Navigation, Scrollbar } from 'swiper/core';
Swiper.use([Navigation]);
Swiper.use([Scrollbar]);

export default class LinkSwiper {
    constructor(elm, args) {
        const slides = elm.querySelectorAll('.swiper-slide');
        const swiperWrapper = elm.querySelector('.swiper-wrapper');
        

        if (slides.length == 0) return;

        this.elm = elm;
        this.options = {
            loop: false,
            slidesPerView: 1.15,
            spaceBetween: 15,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            scrollbar: {
                el: elm.querySelector('.swiper-scrollbar'),
                draggable: true,
            },
            breakpoints: {
                992: {
                    slidesPerView: args.slidesPerView,
                    spaceBetween: 26,
                }
            },
        };

        this.swiper = import('swiper').then(slider => new slider.Swiper(this.elm, this.options));



     
    }

    update() {
        this.swiper.update();
    }

    destroy() {
        this.swiper.destroy();
    }



}
